import { validateRequiredFieldWithArrayValue } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredFieldWithArrayValue';
import { validateRecaptchaVerified } from '@framework/ui/Organisms/FinalForm/validators/validateRecaptchaVerified';
import { groupValidators } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateEmail } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';

const email = { fieldName: 'email', fieldCaption: 'Email' };
const comments = { fieldName: 'comments', fieldCaption: 'Comments', isPlural: true };

export default (values) => groupValidators(
  validateEmail({ ...email, value: values.email }),
  validateRequiredFieldWithArrayValue({ ...comments, value: values.comments }),
  validateRecaptchaVerified({ fieldName: 'recaptcha', value: values.recaptcha }),
);
